import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DialogState from "./state";
import DialogPayload from './payload';

export default createSlice({
  name: "dialog",
  initialState: {
    isOpen: false,
    message: '',
    title: 'Sample title',
    image: '',
    crudDialog: undefined,
  } as DialogState,
  reducers: {
    updateDialog: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isOpen: action.payload
      }
    },
    updateDialogContent: (state, action: PayloadAction<DialogPayload>) => {
      return {
        ...state,
        message: action.payload.message,
        title: action.payload.title,
        image: action.payload.image
      }
    },
    updateDialogInfo: (state, action: PayloadAction<DialogPayload>) => {
      return {
        ...state,
        message: action.payload.message,
        title: action.payload.title,
        name: action.payload.name ? action.payload.name : "",
        image: action.payload.image ? action.payload.image : ""
      }
    },
    updateCrudDialog: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        crudDialog: action.payload
      }
    },
  },
});